import React from 'react';
import { createGuest } from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  targetAddress,
  isBillingAddressMode,
  isEditMode,
  setIsSubmitting,
  setTargetAddress,
  closeModal,
  onSubmit,
  me,
  fetchOnAuthenticated,
  intl,
  setWebSocketToken,
  removeSearchQuery,
) => {
  if (errors.length === 0) {
    isBillingAddressMode
      ? handleSubmitBase(
          'addresses/billing',
          'editBillingAddressSuccess',
          'editBillingAddressError',
          'createNewBillingAddressSuccess',
          'createNewBillingAddressError',
          event,
          errors,
          { ...values, vatId: values.vatId || null },
          {
            ...targetAddress,
            coordinates: targetAddress?.coordinates
              ? targetAddress?.coordinates?.lat +
                ',' +
                targetAddress?.coordinates?.lng
              : '0,0',
          },
          isEditMode,
          setIsSubmitting,
          setTargetAddress,
          closeModal,
          onSubmit,
        )
      : (me
          ? Promise.resolve()
          : createGuest(
              { locale: intl?.locale },
              setWebSocketToken,
            ).then(() => fetchOnAuthenticated())
        ).then(() =>
          handleSubmitBase(
            'addresses/delivery',
            'editDeliveryAddressSuccess',
            'editDeliveryAddressError',
            'createNewDeliveryAddressSuccess',
            'createNewDeliveryAddressError',
            event,
            errors,
            values,
            {
              ...targetAddress,
              coordinates: targetAddress?.coordinates
                ? targetAddress?.coordinates?.lat +
                  ',' +
                  targetAddress?.coordinates?.lng
                : '0,0',
            },
            isEditMode,
            setIsSubmitting,
            setTargetAddress,
            closeModal,
            onSubmit,
          ).then(() => removeSearchQuery()),
        );
  }
};
